export const CardIcon = () => {
    return(
        <svg width="39" height="30" viewBox="0 0 39 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M31.8562 2.2207H7.36587C4.8743 2.2207 2.85449 4.24052 2.85449 6.73208V23.4886C2.85449 25.9802 4.8743 28 7.36587 28H31.8562C34.3478 28 36.3676 25.9802 36.3676 23.4886V6.73208C36.3676 4.24052 34.3478 2.2207 31.8562 2.2207Z" stroke="#00E98A" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M2.85449 9.95459H36.3676M9.29932 18.6551H13.1662V20.2663H9.29932V18.6551Z" stroke="#00E98A" strokeWidth="4" strokeLinejoin="round"/>
</svg>

    )
}